// Living & Sofas
import productImg01 from "../images/double-sofa-01.png";
import productImg02 from "../images/double-sofa-02.png";
import productImg03 from "../images/double-sofa-03.png";
import productImg04 from "../images/single-sofa-01.jpg";
import productImg05 from "../images/single-sofa-02.jpg";
import productImg06 from "../images/single-sofa-03.jpg";
import productImg007 from "../images/single-sofa-04.png";

// Armchairs
import productImg07 from "../images/arm-chair-01.jpg";
import productImg08 from "../images/arm-chair-02.jpg";
import productImg09 from "../images/arm-chair-03.jpg";
import productImg10 from "../images/arm-chair-01.jpg";

// Dining, Coffee & Consoles (Tables)
import tableImg01 from "../images/table-coffee-01.jpg";
import tableImg02 from "../images/table-dining-01.jpg";
import tableImg03 from "../images/table-console-01.jpg";
import tableImg04 from "../images/table.jpg";

// Designer Architectural Lighting
import lightingImg01 from "../images/lighting-floor-01.jpg";
import lightingImg02 from "../images/lighting-table-01.jpg";
import lightingImg03 from "../images/lighting-pendant-01.jpg";

// Home Accents, Mirrors & Decor
import decorImg01 from "../images/decor-vases-01.jpg";
import decorImg02 from "../images/decor-mirror-01.jpg";
import decorImg03 from "../images/decor-cushions-01.jpg";

const products = [
  // ==================== SOFAS ====================
  {
    id: "01",
    productName: "Stone and Beam Westview Sofa",
    imgUrl: productImg01,
    category: "sofa",
    material: "Belgian Linen",
    price: 395,
    shortDesc:
      "Handcrafted three-seater sofa wrapped in durable woven linen with kiln-dried solid hardwood frame.",
    description:
      "Designed for enduring comfort and quiet luxury, the Westview sofa pairs clean architectural lines with down-blend cushions. The kiln-dried European hardwood structure prevents warping, while the stain-resistant textural upholstery ensures family-friendly resilience.",
    reviews: [
      {
        rating: 4.8,
        text: "The fabric quality and cushioning are extraordinary. Elevates our entire living room.",
      },
      {
        rating: 5.0,
        text: "Solid build, incredibly comfortable, and white-glove delivery was flawless.",
      },
    ],
    avgRating: 4.9,
  },

  {
    id: "02",
    productName: "Rivet Bigelow Modern Lounge Couch",
    imgUrl: productImg02,
    category: "sofa",
    material: "Textured Weave",
    price: 480,
    shortDesc:
      "Architectural low-profile couch with deep seating and brushed antique bronze cylindrical feet.",
    description:
      "Inspired by Scandinavian mid-century proportions, the Bigelow couch offers extra-deep seating for effortless lounging. High-resilience memory foam core wrapped in feather fill guarantees shape retention year after year.",
    reviews: [
      {
        rating: 4.7,
        text: "Incredibly deep and cozy, looks like an atelier custom commission.",
      },
    ],
    avgRating: 4.7,
  },

  {
    id: "03",
    productName: "Amazon Brand Curved Sectional",
    imgUrl: productImg03,
    category: "sofa",
    material: "Bouclé",
    price: 540,
    shortDesc:
      "Sculptural curved three-piece sectional in warm oat performance textured bouclé.",
    description:
      "Organic silhouettes meet timeless elegance. The flowing contours create an inviting conversation circle in spacious living rooms, built over a reinforced FSC-certified pine foundation.",
    reviews: [
      {
        rating: 4.9,
        text: "The curve gives our room an ultra-modern designer aesthetic.",
      },
    ],
    avgRating: 4.8,
  },

  {
    id: "04",
    productName: "Fluffy Sheep Bouclé Daybed",
    imgUrl: productImg04,
    category: "sofa",
    material: "Bouclé",
    price: 320,
    shortDesc:
      "Cloud-soft bouclé single sofa daybed featuring high-density dual cushioning and natural ash legs.",
    description:
      "A tactile haven tailored with plush ivory bouclé. Ideal for sunlit reading nooks, master bedrooms, or executive reception areas seeking relaxed refinement.",
    reviews: [
      {
        rating: 4.8,
        text: "Softest texture ever. Perfect reading corner piece.",
      },
    ],
    avgRating: 4.8,
  },

  {
    id: "05",
    productName: "Faux Velvet Chaise Lounge",
    imgUrl: productImg05,
    category: "sofa",
    material: "Velvet",
    price: 375,
    shortDesc:
      "Tailored velvet chaise with ergonomic reclining slope and hand-stitched French piping.",
    description:
      "Rich jewel-toned velvet with a matte vintage luster. Designed for afternoons with a book, equipped with sinuous wire suspension and solid walnut base runners.",
    reviews: [
      {
        rating: 4.6,
        text: "Luxurious velvet feel that doesn't crease or attract dust easily.",
      },
    ],
    avgRating: 4.6,
  },

  {
    id: "06",
    productName: "Nordic Minimalist Linen Sofa",
    imgUrl: productImg06,
    category: "sofa",
    material: "Belgian Linen",
    price: 410,
    shortDesc:
      "Straight-line Scandinavian silhouette with removable, washable natural Belgian linen slipcovers.",
    description:
      "Effortlessly breathable and timelessly relaxed. The removable linen slipcover softens with every wash, celebrating organic textures and mindful craftsmanship.",
    reviews: [
      {
        rating: 4.9,
        text: "Removable covers are a game-changer with kids and pets. Highly recommended.",
      },
    ],
    avgRating: 4.9,
  },

  {
    id: "27",
    productName: "Modern Deep Arm Atelier Sofa",
    imgUrl: productImg007,
    category: "sofa",
    material: "Belgian Linen",
    price: 365,
    shortDesc:
      "Compact two-seater sofa with generous wide armrests that double as perch surfaces.",
    description:
      "Proportioned for modern urban apartments without sacrificing comfort. Features reinforced corner blocks and pocket-coil internal seating springs.",
    reviews: [
      {
        rating: 4.7,
        text: "Clean, crisp design. Fits our living room perfectly.",
      },
    ],
    avgRating: 4.7,
  },

  // ==================== CHAIRS & ARMCHAIRS ====================
  {
    id: "07",
    productName: "Sakarias Lounge Armchair",
    imgUrl: productImg07,
    category: "chair",
    material: "Solid Ash Wood & Canvas",
    price: 185,
    shortDesc:
      "Generously proportioned lounge chair with high wrap-around back and solid ash wood legs.",
    description:
      "The Sakarias armchair envelops the body in supportive serenity. Designed for dining heads or fireside relaxing, featuring fire-retardant foam and removable cushion covers.",
    reviews: [
      {
        rating: 4.8,
        text: "Super comfortable for hours of sitting, great lumbar support.",
      },
    ],
    avgRating: 4.8,
  },

  {
    id: "08",
    productName: "Baltsar Sculptural Chair",
    imgUrl: productImg08,
    category: "chair",
    material: "Textured Weave",
    price: 145,
    shortDesc:
      "Curved tub-style accent chair upholstered in textured weave fabric with black powder-coated swivel base.",
    description:
      "Dynamic 360-degree silent swivel mechanism makes the Baltsar as versatile as it is striking. Perfect for creative studios, home libraries, and contemporary dining tables.",
    reviews: [
      {
        rating: 4.7,
        text: "The smooth swivel and rounded backrest make this my favorite desk chair.",
      },
    ],
    avgRating: 4.7,
  },

  {
    id: "09",
    productName: "Helmar Ash Wood Armchair",
    imgUrl: productImg09,
    category: "chair",
    material: "Solid Ash Wood",
    price: 195,
    shortDesc:
      "Exposed solid European ash timber frame paired with thick canvas and foam-core cushions.",
    description:
      "Honoring honest joinery and architectural woodwork. The precision-milled ash frame reveals natural grain variations, hand-finished with organic matte wax.",
    reviews: [
      {
        rating: 5.0,
        text: "True Scandinavian masterpiece. Build quality is top-notch.",
      },
    ],
    avgRating: 4.9,
  },

  {
    id: "10",
    productName: "Ekenäset Mid-Century Velvet Armchair",
    imgUrl: productImg10,
    category: "chair",
    material: "Velvet",
    price: 210,
    shortDesc:
      "Iconic 1950s silhouette updated with heavy cotton velvet and tapered walnut-stained beech arms.",
    description:
      "Vintage soul with modern resilience. Designed to be viewed and admired from all 360 degrees with refined back detailing.",
    reviews: [
      {
        rating: 4.8,
        text: "Classy vintage look. The wood arms have a silky smooth finish.",
      },
    ],
    avgRating: 4.8,
  },

  // ==================== TABLES & CONSOLES ====================
  {
    id: "11",
    productName: "Aura Fluted Marble Coffee Table",
    imgUrl: tableImg01,
    category: "table",
    material: "Carrara Marble & Solid Oak",
    price: 340,
    shortDesc:
      "Round honed Carrara marble top sitting on an artisanal fluted solid natural oak pedestal base.",
    description:
      "A stunning centerpiece for refined living rooms. The natural grey veining of the honed marble contrasts warmly against vertical oak fluting, protected by an invisible matte sealant against spills.",
    reviews: [
      {
        rating: 5.0,
        text: "The marble top is heavy and genuine, and the fluted wood base is pure art.",
      },
      {
        rating: 4.9,
        text: "Everyone who visits asks where we got this table. Spectacular quality!",
      },
    ],
    avgRating: 5.0,
  },

  {
    id: "12",
    productName: "København Solid Oak Dining Table",
    imgUrl: tableImg02,
    category: "table",
    material: "Solid White Oak",
    price: 680,
    shortDesc:
      "Extendable 6 to 8-seater dining table crafted from sustainable Nordic white oak with soft rounded edges.",
    description:
      "Crafted for memorable family gatherings. Features softly rounded bullnose edges, heavy cylindrical legs, and a smooth buttery surface treated with non-toxic botanical oil.",
    reviews: [
      {
        rating: 4.9,
        text: "Solid oak through and through. Incredible craftsmanship that will last generations.",
      },
    ],
    avgRating: 4.9,
  },

  {
    id: "13",
    productName: "Søren Sculptural Walnut Console Table",
    imgUrl: tableImg03,
    category: "table",
    material: "American Walnut & Travertine",
    price: 420,
    shortDesc:
      "Curved fluid American walnut console table featuring a rough-chiselled natural travertine top shelf.",
    description:
      "A sculptural statement for entryways and living corridors. The organic sweeping walnut base defies gravity, crowned with an artisan-chiseled travertine stone surface.",
    reviews: [
      {
        rating: 4.9,
        text: "Breathtaking in person. Truly looks like a museum gallery installation.",
      },
    ],
    avgRating: 4.9,
  },

  {
    id: "14",
    productName: "Stockholm Round Bistro Table",
    imgUrl: tableImg04,
    category: "table",
    material: "Solid White Oak",
    price: 240,
    shortDesc:
      "Compact 36-inch round breakfast table with cast iron pedestal base and wire-brushed oak veneer.",
    description:
      "Ideal for morning coffee corners, compact dining alcoves, or creative studio meeting zones. The weighted base ensures rock-solid stability.",
    reviews: [
      {
        rating: 4.7,
        text: "Sturdy, doesn't wobble at all, and looks charming with our bentwood chairs.",
      },
    ],
    avgRating: 4.7,
  },

  // ==================== DESIGNER LIGHTING ====================
  {
    id: "15",
    productName: "Vesper Brushed Brass Arc Floor Lamp",
    imgUrl: lightingImg01,
    category: "lighting",
    material: "Brushed Brass",
    price: 290,
    shortDesc:
      "Sweeping architectural brass arch with a delicate pleated paper conical shade and weighted brass base.",
    description:
      "Casts warm, diffused ambient luminescence across seating arrangements without taking up tabletop space. Equipped with a foot-switch dimmer and braided fabric cord.",
    reviews: [
      {
        rating: 5.0,
        text: "Creates the most romantic, warm ambiance in our lounge. Absolute perfection.",
      },
    ],
    avgRating: 5.0,
  },

  {
    id: "16",
    productName: "Lumina Tactile Ceramic Mushroom Table Lamp",
    imgUrl: lightingImg02,
    category: "lighting",
    material: "Ceramic Stoneware",
    price: 165,
    shortDesc:
      "Hand-thrown matte stoneware mushroom table lamp with integrated 2700K warm LED glow.",
    description:
      "Tactile, grounding, and atmospheric. The unglazed textured ceramic body radiates peaceful serenity on nightstands, bookshelves, and side consoles.",
    reviews: [
      {
        rating: 4.9,
        text: "The textured ceramic is gorgeous and the warm light is so gentle on the eyes.",
      },
    ],
    avgRating: 4.9,
  },

  {
    id: "17",
    productName: "Solstice Frosted Glass Globe Chandelier",
    imgUrl: lightingImg03,
    category: "lighting",
    material: "Brass & Opal Glass",
    price: 490,
    shortDesc:
      "Linear branching brass chandelier featuring 8 handblown frosted opal glass illumination spheres.",
    description:
      "An architectural ceiling centerpiece designed to suspend effortlessly over dining tables or kitchen islands. Fully dimmable with adjustable hanging drop rods.",
    reviews: [
      {
        rating: 4.9,
        text: "Transformed our dining area completely. High-end gallery aesthetic.",
      },
    ],
    avgRating: 4.9,
  },

  // ==================== HOME DECOR & ACCENTS ====================
  {
    id: "18",
    productName: "Kanso Stoneware Ceramic Vase Trio",
    imgUrl: decorImg01,
    category: "decor",
    material: "Ceramic Stoneware",
    price: 115,
    shortDesc:
      "Artisanal set of three textured earthenware vases in natural sand, terracotta, and matte charcoal.",
    description:
      "Handcrafted by ceramic artisans using raw clays and tactile reactive glazes. Perfect styled together on a dining table or placed individually throughout your shelves.",
    reviews: [
      {
        rating: 4.8,
        text: "Heavy, earthy, and gorgeous. Each piece has subtle unique artisan markings.",
      },
    ],
    avgRating: 4.8,
  },

  {
    id: "19",
    productName: "Arcadia Asymmetrical Brass Wall Mirror",
    imgUrl: decorImg02,
    category: "decor",
    material: "Brushed Brass",
    price: 260,
    shortDesc:
      "Pond-inspired organic curved wall mirror with a slender 4mm hand-brushed antique brass rim.",
    description:
      "Brings natural light, depth, and organic movement into hallways and living areas. High-definition silvered glass with anti-shatter safety backing and multi-directional hangers.",
    reviews: [
      {
        rating: 5.0,
        text: "Looks like a liquid drop on the wall. Incredible reflection clarity and craftsmanship.",
      },
    ],
    avgRating: 5.0,
  },

  {
    id: "20",
    productName: "Heirloom Bouclé & Heavy Linen Cushion Suite",
    imgUrl: decorImg03,
    category: "decor",
    material: "Bouclé & Linen",
    price: 85,
    shortDesc:
      "Set of luxury textured bouclé and washed Belgian linen accent pillows filled with premium down alternative.",
    description:
      "Layering tactile warmth onto leather and fabric sofas. Hypoallergenic micro-cluster fiber fill ensures plush sink-in comfort with concealed brass zipper closures.",
    reviews: [
      {
        rating: 4.8,
        text: "Plump, premium feel and the texture pairing is so luxurious.",
      },
    ],
    avgRating: 4.8,
  },
];

export default products;
